import React, { useEffect, useState } from "react";
import Loader from "./Loader";

const ConfirmationPopup = ({
    isOpen,
    onConfirm = () => {}, // Default to no-op function
    
    loading,
}) => {
    const [showLoader, setShowLoader] = useState(true);

    useEffect(() => {
        if (isOpen) {
            document.documentElement.style.overflow = "hidden";
            document.body.style.overflow = "hidden";

            setShowLoader(true);
            const timer = setTimeout(() => {
                setShowLoader(false);
            }, 1000);

            return () => {
                clearTimeout(timer);
                document.documentElement.style.overflow = "auto";
                document.body.style.overflow = "auto";
            };
        }
    }, [isOpen]);

    if (!isOpen) return null;
    

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-d">
            {showLoader ? (
                <Loader />
            ) : (
                <div className="bg-white p-[15px] pt-[25px] rounded-[27px] shadow-xl w-[22%] md:w-[50%] sm:w-[91%] relative flex flex-col items-center">
                    {/* Close Button */}
                    <p className="text-gray-600 text-center flex items-center justify-center  p-[1px]">
                    
                        <img
                            src="https://jobcritics.com/assets/img/biar/report.webp"
                            alt="Delete"
                            className="w-[150px] mr-2"
                        />
                    </p>
                    {/* 
                    Title & Message */}
                    <h6 className="font-semibold text-black text-center w-full mb-0 mt-[14px] pb-[5px]">Pending Review</h6>

                    <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[15px]">This rating is already under moderation. Further actions are temporarily disabled.</p>

                    {/* Success Message with Icon */}


            
                                <button
                                    className="btn-explore-yellow text-c pd3 dsfa"
                                    onClick={onConfirm}
                                    disabled={loading}
                                >
                                    OK
                                </button>
                        </div>
                    )}
                </div>
    );
};

export default ConfirmationPopup;